import { ObjectLiteral } from "./user";

interface FlightInfo {
    actualArrivalDateTime?: any;
    actualDepartureDateTime?: any;
    estimatedArrivalDateTime?: string;
    estimatedDepartureDateTime?: string;
    minutesDelayed?: string;
    scheduledArrivalDateTime?: string;
    scheduledDepartureDateTime?: string;
    statusCode?: string;
    statusMessage?: string;
    tailNumber?: string;
}

interface FlightStatuses {
    code: string;
    description: string;
    statusType: string;
}

interface FlightStatus {
    description: string;
    className: string;
}

export interface FlightDetailsResponse {
    action: string
    success: boolean
    data: Object
    confirmationID: string
    travelers: any[]
    segments: any[]
    travelReady: boolean
    score: number
    keyAttributes: string
    docCheckRegion: string
    globalirrops: boolean
    isIrrop: boolean
    multiplePnr: boolean
}

export interface FlightOption {
    departureTimeZone: string;
    origin: string
    originDescription?: any
    destination: string
    destinationDescription?: any
    departDateTime: string
    airfare: number
    connections: FlightOption[]
    connectTimeMinutes:	any
    operatingCarrier: any
    bookingClassAvailability: string
    destinationDateTime: string
    fareBasisCode?: any
    flightNumber: string
    arrivalGate: string
    arrivalOffset: string
    arrivalTimeZone: string
    flightInfo?: FlightInfo
    originCountryCode: string
    flightStatuses: FlightStatuses[]
    operatingCarrierCode: string
    operatingCarrierDescription: string
    operatingCarrierName: string

    available: boolean // custom
    flightStatus?: FlightStatus // custom
    
}
export interface FlightOptionsResponse {
    action: string
    success: boolean
    data: Object
    alertFlag: null
    arrivalAirports: string
    dataSource: string
    departureAirports: string
    errors?: any[]
    trips: Trips[]
    code: number
}

export interface FlightOptionsRequest {
    pnr: string;
    lastName: string;
    date: string;
    orig: string;
    dest: string;
    time: string;
}

export interface Trips {
    departDate: string;
    departTime: string;
    departTimeApprox: number;
    flightCount: number;
    selected: boolean;
    flights: FlightOption[];
}

export const newEmptyFlightOption = (): FlightOption => ({
    origin: '',
    originDescription: '',
    destination: '',
    departDateTime: '',
    airfare: null,
    connections: [],
    connectTimeMinutes:	'',
    operatingCarrier: '',
    bookingClassAvailability: '',    
    destinationDateTime: '',
    fareBasisCode: '',
    flightNumber: '',
    arrivalGate: '',
    arrivalOffset: '',
    arrivalTimeZone: '',
    flightInfo: null,
    originCountryCode: '',
    flightStatuses: null,
    operatingCarrierCode: '',
    operatingCarrierDescription: '',
    operatingCarrierName: '',
    available: true,
    flightStatus: null,
    departureTimeZone: ''
}
)

export interface ChangeFlightSegmentsRequest {
    pnr: string
    lastName: string
    insertSegments: InsertFlightSegment[]
    deleteSegments: DeleteFlightSegment[]
}

export interface ChangeFlightSegmentsResponse {
    action: string
    success: boolean
    data: Object
}

export interface InsertFlightSegment {
    dest: string
    bookingClasses: InsertFlightSegmentBookingClasses[]
    orig: string
    departureDateTime: string
    flightNumber: string
    operatingCarrierCode: string
    travelerCount: Object
}

export interface InsertFlightSegmentBookingClasses {
    code: string
}

export interface DeleteFlightSegment {
    segmentNumber: string
}